import { render } from "./ShowUpdateCompanyComponent.vue?vue&type=template&id=f8b91c5c"
import script from "./ShowUpdateCompanyComponent.vue?vue&type=script&lang=js"
export * from "./ShowUpdateCompanyComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__